import { OrderStepChange } from './order.step-change';

/**
 * @interface OrderInterface
 */
export class OrderInterface extends OrderStepChange {}
